import { PciI } from "interfaces/Pci";
import { Button, Modal } from "react-bootstrap";
import { PCIDetailPanel } from "../PCICompareModal/PCIDetailPanel";

interface Props {
  onClose?: any;
  elemento: PciI | null;
  showModal: boolean;
}

export const PCIDetailModal = ({ elemento, showModal, onClose }: Props) => {
  return (
    <>
      <Modal show={showModal} onHide={onClose} size="xl" centered>
        <Modal.Header>
          <Modal.Title>{"Detalle PCI:"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PCIDetailPanel elemento={elemento} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-3"
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
